<template>
    <div class="grid gap-16 grid-cols-1">
        <div v-for="job in productJobs">
            <JobBoardVacancyListItem :product="product" :job="job" />
        </div>
    </div>
</template>

<script>

import JobBoardVacancyListItem from "./JobBoardVacancyListItem.vue";
import {mapState} from "pinia";
import {useMultiPostingStore} from '../../state/modules/multiPosting';

export default {
    name: 'JobBoardVacancyList',
    components: {JobBoardVacancyListItem},
    props: {
        product: {type: Object, required: true},
    },
    computed: {
        ...mapState(useMultiPostingStore, ['productJobs']),
    }
}
</script>
